"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-63b1e388"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "summary-date-nav-wrapper" };
const vue_3 = require("vue");
const DateNav_vue_1 = __importDefault(require("../../../vue/DateNav.vue"));
const TagRoleFilterModal_vue_1 = __importDefault(require("../../../vue/TagRoleFilterModal.vue"));
const provider_1 = require("../../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryDateNavView',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.dateNavViewModelInjectKey);
        const tagRoleFilterModal = (0, vue_3.ref)(null);
        function openTagRoleFilterModal() {
            tagRoleFilterModal.value?.openModal();
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#tag-role-filter-modal" }, [
                    (0, vue_2.createVNode)(TagRoleFilterModal_vue_1.default, {
                        ref_key: "tagRoleFilterModal",
                        ref: tagRoleFilterModal,
                        "modal-name": "tag-role-filter",
                        "company-ID": (0, vue_2.unref)(viewModel)?.activeCompanyID,
                        tags: (0, vue_2.unref)(viewModel)?.tags,
                        roles: (0, vue_2.unref)(viewModel)?.roles
                    }, null, 8 /* PROPS */, ["company-ID", "tags", "roles"])
                ])),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(DateNav_vue_1.default, {
                        "active-company-i-d": (0, vue_2.unref)(viewModel)?.activeCompanyID,
                        "start-date": (0, vue_2.unref)(viewModel)?.startDate || new Date(),
                        "end-date": (0, vue_2.unref)(viewModel)?.endDate || new Date(),
                        "time-period-type": (0, vue_2.unref)(viewModel)?.timePeriodType,
                        "current-page": (0, vue_2.unref)(viewModel)?.currentPage,
                        "show-daily-button": (0, vue_2.unref)(viewModel)?.showDailyButton,
                        "hide-period-selector": (0, vue_2.unref)(viewModel)?.hidePeriodSelector,
                        onOpenTagRoleFilterModal: openTagRoleFilterModal
                    }, null, 8 /* PROPS */, ["active-company-i-d", "start-date", "end-date", "time-period-type", "current-page", "show-daily-button", "hide-period-selector"])
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
